import React, { useContext } from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ErrorBoundary from '../ErrorBoundary';
import LazyContext from '../LazyLoadingImage/LazyContext';
import SidebarBlock from './SidebarBlock';
import LoaderBlock from './_partials/LoaderBlock';
import s from './Sidebar.scss';
const Sidebar = ({ deviation, className })=>{
    var _deviation_extended, _deviation;
    const isDesktop = !useContext(MobileContext);
    const isPromoHigherMobileFlagEnabled = useFlag('promo_higher_mobile');
    const isExpNoSide = useFlag('seo_exp_noside');
    const blocks = (_deviation = deviation) === null || _deviation === void 0 ? void 0 : (_deviation_extended = _deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.relatedContent;
    const isLoading = !deviation.extended;
    const shouldRenderSidebarBlock = (block)=>{
        if (isDesktop) {
            return true;
        }
        // mobile
        const isMonetizationPromoBlock = block.contentType.startsWith('monetization_promotion');
        if (isPromoHigherMobileFlagEnabled && isMonetizationPromoBlock) {
            // this feature flag puts these blocks higher in the layout on mobile
            return false;
        }
        if ([
            'adoptable_info',
            'pcp_info'
        ].includes(block.contentType)) {
            // adoptable_info and pcp_info are shown in a different zone on mobile
            return false;
        }
        return true;
    };
    if (isExpNoSide) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Sidebar"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        role: "complementary"
    }, !isLoading && blocks && blocks.map((block, index)=>shouldRenderSidebarBlock(block) && /*#__PURE__*/ React.createElement(LazyContext.Provider, {
            value: isDesktop ? index > 1 : true,
            key: block.contentType
        }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                _rankOffset: 0
            }
        }, /*#__PURE__*/ React.createElement(SidebarBlock, {
            block: block,
            deviation: deviation
        })))), isLoading && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 0
    }), /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 1
    }), /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 2
    }))));
};
Sidebar.displayName = 'Sidebar';
export default Sidebar;
